import React, { useContext } from 'react';

export const SearchContext = React.createContext(null);

export function useSearchContext() {
    return useContext(SearchContext);
}
